'use client';

import Link from 'next/link';
import { siteName } from '@/lib/site';
import ElseHavenLogo from './svg/ElseHavenLogo';
import PublicMenuButton from './PublicMenuButton';

type PublicHeaderProps = {
  variant?: 'light' | 'dark';
  contextName?: string;
  className?: string;
};

export default function PublicHeader({
  variant = 'light',
  contextName,
  className = '',
}: PublicHeaderProps) {
  const baseClass =
    variant === 'dark'
      ? 'text-white border-b border-white/20 bg-black/20 backdrop-blur z-40'
      : 'text-foreground border-b border-border bg-background/70 backdrop-blur z-40';
  const showLogo = process.env.NEXT_PUBLIC_HEADER_LOGO === 'true';
  const featureFlag = process.env.NEXT_PUBLIC_FEATURE_FLAG_LABEL;
  return (
    <div className={`${baseClass} ${className} relative`}>
      {featureFlag && (
        <div className="absolute left-4 top-2 z-50">
          <span className="inline-flex items-center rounded-full border border-border bg-card/90 px-2 py-1 text-[10px] font-semibold tracking-wide text-foreground">
            {featureFlag}
          </span>
        </div>
      )}
      <div className="mx-auto max-w-6xl px-6 h-16 grid grid-cols-[1fr_auto_1fr] items-center">
        <div className="flex items-center h-full">
          {showLogo && <ElseHavenLogo variant={variant} className="h-full w-16 shrink-0" />}
        </div>
        <Link href="/" className="text-center text-sm font-semibold uppercase tracking-[0.3em]">
          {siteName}
        </Link>
        <div className="flex justify-end">
          <PublicMenuButton variant={variant === 'dark' ? 'dark' : 'light'} contextName={contextName} />
        </div>
      </div>
    </div>
  );
}
